import { type AutocompleteProps, Autocomplete, TextField } from '@mui/material';

type FilterAutocompleteType = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  props: Omit<AutocompleteProps<any, boolean, boolean, false>, 'renderInput'> & {
    textFieldLabel?: React.ReactNode;
  };
};

const FilterAutocomplete = (props: FilterAutocompleteType['props']) => (
  <Autocomplete
    size="small"
    fullWidth
    disablePortal
    {...props}
    {...(props.multiple ? { disableCloseOnSelect: true } : {})}
    renderInput={(params) => (
      <TextField
        {...params}
        label={props.textFieldLabel ?? ''}
        size="small"
        {...(props.size === 'small' && { InputLabelProps: { sx: { fontSize: 14 } } })}
        slotProps={{
          htmlInput: { ...params.inputProps, autoComplete: 'new-password' },
        }}
      />
    )}
  />
);

export default FilterAutocomplete;
